export default class NetAuditRecord {
    constructor(destination, quantity, type) {
        this.destination = destination;
        this.quantity = quantity;
        this.type = type;
    }
}